import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=59ed96a7&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed96a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ed96a7')) {
      api.createRecord('59ed96a7', component.options)
    } else {
      api.reload('59ed96a7', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=59ed96a7&scoped=true&", function () {
      api.rerender('59ed96a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/icon/Icon.vue"
export default component.exports